/**
 * RequestTypes is global method
 * Using RequestTypes we can assign methods
 * example: RequestTypes.get, RequestTypes.post
 */
export enum RequestTypes {
    get,
    post,
    put,
    delete,
    patch,
    head,
    options
}
/**
 * IUrlOptions is interface object, created for define types
 * Should be second param of Request
 * example: {
      restOfUrl: 'https://jsonplaceholder.typicode.com/posts/1',
      endPoint: '',
      isSecure: true,
      contentType: 'application/json'
    }
 */
export interface IUrlOptions {
    restOfUrl: string;
    endPoint: string;
    isSecure: boolean;
    contentType: string;
    customHeader?: any[];
}

export interface IAuthenticationResult {
    IsAuthenticated: boolean;
}
